<template>
  <v-row no-gutters>
    <v-col cols="12" class="px-2 register-success-dialog">
      <div class="step-display">
        <div class="step" v-for="n in 2">
          <span>{{ n }}</span>
        </div>
        <div class="step active">
          <span class="material-icons">check</span>
        </div>
      </div>
      <v-row no-gutters>
        <v-col cols="12">
          <div class="icon">
            <img loading="lazy" src="/static/image/register/icon-check.png" width="120" alt="bhai88 register check" />
          </div>
          <p class="congratulations-title">{{ $t('label.congratulations') }}🎉</p>
          <p class="text-center">
            {{ $t('label.register_success_desc_1') }}
          </p>
          <div class="text-center pb-2">
            {{ $t('label.register_success_desc_2') }}
            <p class="text-center highlight">{{ $t('label.register_success_desc_3') }}</p>
            <p class="text-center highlight mb-0">{{ $t('label.register_success_desc_4') }}</p>
            <p class="text-center highlight mb-0">{{ $t('label.register_success_desc_5') }}</p>
            <p class="text-center highlight">{{ $t('label.register_success_desc_6') }}</p>
            <p class="text-center highlight">{{ $t('label.register_success_desc_7') }}</p>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="mb-3">
          <app-button class="full-width circle-button text-capitalize" :title="$t(`label.depositToYourAccountAndStartPlaying`)" :action="this.goToDepositPage"></app-button>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper } from '@/util'
import { SESSION } from '@/constants/constants'
import $ from 'jquery'
import { MEMBER_DETAIL } from '@/store/member.module'
export default {
  name: 'registerSuccess',
  props: {
    closeRegisterSuccessDialog: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  created() {
    if (uiHelper.getCookie(SESSION.UTM_S2) != null) {
      this.firePixel()
    }
    this.getMemberDetails()
  },
  computed: {
    memberInfo() {
      return this.$store.state.member.info
    }
  },
  watch: {
    memberInfo(m) {
      if (m && m.id) {
        let vip = m.group
        uiHelper.setCookie(SESSION.MEMBER_ID, m.id, 1)
        uiHelper.setCookie(SESSION.VIP, vip, 1)
        this.currentCurrency = uiHelper.getCurrency()

        // FIRE PIXEL HERE once memberInfo is ready
        //this.fireVoluumPixel()
      }
    }
  },
  methods: {
    getMemberDetails() {
      this.$store.dispatch(`${MEMBER_DETAIL}`)
    },
    fireVoluumPixel() {
      const memberId = uiHelper.getCookie(SESSION.MEMBER_ID)
      const clickId = uiHelper.getCookie(SESSION.UTM_S1)
      if (!clickId || !memberId) {
        console.warn('Missing clickId or memberId, skip Voluum pixel')
        return
      }
      const uniqueKey = `${clickId}_${memberId}`

      // Check if already sent
      if (localStorage.getItem('send_voluum') === uniqueKey) {
        console.log('Voluum pixel already sent for this user/click')
        return
      }
      try {
        let url = 'https://vv2233.malayluck.com/postback?cid=' + uiHelper.getCookie(SESSION.UTM_S1) + '&et=register' + '&txid=' + uiHelper.getCookie(SESSION.MEMBER_ID)
        $.get(url, function(data) {
          console.log(data)
        })
      } catch (err) {
        console.log(err)
      }
      localStorage.setItem('send_voluum', uniqueKey)
    },
    firePixel() {
      try {
        let url = 'https://e5xbo.rdtk.io/postback?clickid=' + uiHelper.getCookie(SESSION.UTM_S2) + '&sum=1'
        $.get(url, function(data) {
          console.log(data)
        })
      } catch (err) {
        console.log(err)
      }
      try {
        let url = 'https://track1122.malayluck.com/postback?clickid=' + uiHelper.getCookie(SESSION.UTM_S2) + '&sum=1'
        $.get(url, function(data) {
          console.log(data)
        })
      } catch (err) {
        console.log(err)
      }
    },
    goToDepositPage() {
      this.$router.push({
        name: ROUTE_NAME.DEPOSIT
      })
      this.closeRegisterSuccessDialog()
    }
  }
}
</script>

<style lang="scss">
.resgiter-dialog-pagination {
  background-color: #acacac;
  color: #ffffff !important;
}

.resgiter-dialog-pagination-active {
  background-color: #14805e;
  border-radius: 30px;
  color: white !important;
}

.resgiter-dialog-pagination.theme--light.v-btn.v-btn--disabled {
  color: #ffffff !important;
}

.register-success-dialog {
  font-size: 14px;
  color: white;
  background: transparent linear-gradient(130deg, #3d3360 0%, #0f0a20 100%) 0% 0% no-repeat padding-box;
  border-radius: 5px;

  .icon {
    display: flex;
    font-size: 16px;
    font-weight: bolder;
    justify-content: center;
    margin: 6px auto 24px;
    color: var(--v-secondary-base);

    p {
      margin-left: -14px;
    }
  }

  p {
    &.highlight {
      color: #ffc000;
    }
  }

  .congratulations-title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  .circle-button {
    padding: 12px;
    border-radius: 8px;
    height: 45px;
    font-size: 12px;
    color: #322c44;
    background: #ffc000 0 0 no-repeat padding-box;
  }

  & {
  }
}
</style>
